<template lang="pug">
  ProgramSettingsFormWrapper#welcome-card(
    setting-type="settings"
    :form-data="formData"
    :disable-save.sync="disableSave"
    :keys-to-reset="keysToReset"
    title="Welcome Card"
  )
    ContentLoader(:height="120" v-if="!programLoaded")
      rect(x="0", y="0", rx="4", ry="4", width="50%", height="15%")
      rect(x="0", y="20%", rx="4", ry="4", width="100%", height="80%")
    template(v-else)
      .is-block
        BField
          WtLabel(
            slot="label"
            text="Welcome Card Text"
            tooltip-text="This message is shown at the top of a new member's dashboard until they have logged in two times."
            label-for="welcomeCardText"
          )
          BInput#welcomeCardText(
            name="welcome card"
            type="textarea"
            maxlength="1000"
            v-model="welcomeText"
            @input="disableSave = isOriginalValue('welcomeText', welcomeText)"
          )
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import programSettingsFormMixin from "@/mixins/programSettingsFormMixin";
import ProgramSettingsFormWrapper from "@@/ProgramSettingsAdmin/ProgramSettingsFormWrapper";
import { ContentLoader } from "vue-content-loader";
import WtLabel from "@@/WtLabel/WtLabel";

export default {
  name: "WelcomeCard",

  components: { WtLabel, ProgramSettingsFormWrapper, ContentLoader },

  mixins: [programSettingsFormMixin],

  computed: {
    ...mapGetters("program", [
      "coreProgramMeta",
      "programSettingsCopy",
      "programLoaded"
    ]),

    formData() {
      return {
        welcomeText: this.welcomeText
      };
    },

    keysToReset() {
      return ["welcomeText"];
    },

    welcomeText: {
      set(welcomeText) {
        this.updateProgramSettingsCopy({
          key: "welcomeText",
          value: welcomeText
        });
      },
      get() {
        return this.sanitize(this.programSettingsCopy.welcomeText, {
          allowedTags: [],
          allowedAttributes: {}
        });
      }
    }
  },

  methods: {
    ...mapActions("program", ["updateProgramSettingsCopy"])
  }
};
</script>
